import React, { useEffect } from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, isResponsive, isSmartphone} from "../../components/Utils";
import {INDIVIDUAL_PROTECTION_CODE, URL_FOR_RESOURCES} from "../../app/AppConfig";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {SpinnerOnTop} from "../../components/SpinnerOnTop";
import { getTaxons } from "../Taxons/TaxonSlice";

interface ComponentProps {
  showInSidebar: boolean,
  isEndOfStock: boolean
}
const CategoriesIndividualEquipment: React.FC<ComponentProps>  = ({ showInSidebar ,isEndOfStock}) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale);

  const taxonsIndivProtection = useSelector((state: RootState) => state.taxonRdc.taxons);
  const isRequesting = useSelector((state: RootState) => state.taxonRdc.isRequesting);
  const taxonomyParent = INDIVIDUAL_PROTECTION_CODE;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getTaxons(locale));
  }, []);

  if (isRequesting) {
    return <SpinnerOnTop />;
  }

  const filteredTaxons = taxonsIndivProtection?.filter(
    (a) => a.parentCode === taxonomyParent
  );

  if (showInSidebar) {
    // Affichage en ul/li
    return (
      <ul className="subtaxon-menu">
        {filteredTaxons?.map((taxonItem) => (
          <li key={taxonItem.code}>
            <a href={`${t("url_catalogue")}?${INDIVIDUAL_PROTECTION_CODE}=${taxonItem.code}&isEndOfStock=${isEndOfStock}`}>
              <img width="40" height="40" src={`${URL_FOR_RESOURCES}${taxonItem.icon}`} alt={taxonItem.name}/>
              {taxonItem.name}
            </a>
          </li>
        ))}
      </ul>
    );
  }

  // Affichage en style "boxed"
  return (
    <div className="container">
      <div className="row all-equipment align-items-center justify-content-center pb-5 mb-5">
        <div className={isResponsive || isSmartphone ? "col-md-12" : "col-md-10"}>
          <div className="row">
            {filteredTaxons?.map((taxonItem, indexTaxon) => (
              <div className="col nopadding" key={taxonItem.code}>
                <a
                  href={`${t("url_catalogue")}?${INDIVIDUAL_PROTECTION_CODE}=${taxonItem.code}`}
                  className="boxed-link"
                >
                  <div className="py-4 px-2 text-center">
                    <span className="icon icon-md rounded-circle mb-3">
                      <img
                        width="45"
                        height="45"
                        src={`${URL_FOR_RESOURCES}${taxonItem.icon}`}
                        alt={taxonItem.name}
                      />
                    </span>
                    <span className="text">{taxonItem.name}</span>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoriesIndividualEquipment;
